/**
 * 源站 tau777.mx（镜像 h5i6.com）rem 实测（CDP，375 / 500 / 1920 三档视口均为）：
 *   html { font-size: 18px }  —— 固定值，不随视口变化
 *   .mobile-root { max-width: 500px; margin: 0 auto }
 * Tailwind 任意值 `text-[14px]` 经 px→rem(16) 转换后实际 = 14 × 18/16 = 15.75px，
 * 即所有设计稿 px × 1.125。本皮肤所有尺寸一律写成 `设计px / 16` rem，根字号固定 18px。
 * 禁止套用 oro-mx 的 750/37.5 cap 450 公式或 lor-us 的 375/16。
 */
export const ROSA_MX_ROOT_FONT_PX = 18;
export const ROSA_MX_MAX_WIDTH = 500;

const ROOT_FONT_ATTR = 'data-rosa-mx-root-font';

export function bindRosaMxRem(): () => void {
  const root = document.documentElement;
  const previous = root.style.fontSize;
  root.style.fontSize = `${ROSA_MX_ROOT_FONT_PX}px`;
  root.setAttribute(ROOT_FONT_ATTR, String(ROSA_MX_ROOT_FONT_PX));
  return () => {
    root.style.fontSize = previous;
    root.removeAttribute(ROOT_FONT_ATTR);
  };
}

/** 设计稿 px → 实际 CSS px（固定 1.125）。用于需要像素运算的地方（拖拽夹取等）。 */
export function rosaMxDesignToPx(design: number) {
  return (design / 16) * ROSA_MX_ROOT_FONT_PX;
}
